import _request from '@/utils/request';
import { _getQuerystr } from '@/utils/commonUtils';


// /staff/diyAiChild/getAiChildINfo 用户 - 查询diy娃娃信息
export async function getAiChildINfo(params) {
  const url = `/staff/diyAiChild/getAiChildInfo${_getQuerystr(params)}`;
  return await _request({
    method: 'GET',
    url
  });
}

// /staff/activity/listByStaff 活动查询
export async function listByStaff(params) {
  const url = `/staff/activity/listByStaff${_getQuerystr(params)}`;
  return await _request({
    method: 'GET',
    url
  });
}

// /staff/activity/listReport用户 - 分页查询用户的活动报告list
export async function getActivityListReports(params) {
  const url = `/staff/activity/listReport${_getQuerystr(params)}`;
  return await _request({
    method: 'GET',
    url
  })
}

// /staff/diyAiChild/create 用户提交创建diy娃娃信息
export async function diyAiChildCreate(params) {
  const url = `/staff/diyAiChild/create`;
  return await _request({
    method: 'POST',
    url,
    data: params,
  })
}

// /staff/diyAiChild/createInnerChildReport 用户 - 创建内在小孩报告
export async function createInnerChildReport(params) {
  const url = `/staff/diyAiChild/createInnerChildReport`;
  return await _request({
    method: 'POST',
    url,
    data: params,
  })
}

// /staff/xiaozhi/bind/{deviceCode}用户 - 绑定设备设备
export async function bindXiaozhi(deviceCode) {
  const url = `/staff/xiaozhi/bind/${deviceCode}`;
  return await _request({
    method: 'POST',
    url,
  })
}

// 新增 get :/staff/diyAiChild/myAvartar 查询当前登录用户的内在娃娃对应的avatar，如果没有则返回null
export async function getMyAvatar(params) {
  const url = `/staff/diyAiChild/myAvatar${_getQuerystr(params)}`;
  return await _request({
    method: 'GET',
    url,
  })
}

// /staff/diyAIChild/images 获取DIY AI娃娃图片列表
export async function getDiyAIChildImages(params) {
  const url = `/staff/diyAIChild/images${_getQuerystr(params)}`;
  return await _request({
    method: 'GET',
    url,
  })
}

// /staff/diyAiChild/teamFeatures 获取团队特征/娃娃部件
export async function getTeamFeatures(params) {
  const url = `/staff/diyAiChild/teamFeatures${_getQuerystr(params)}`;
  return await _request({
    method: 'GET',
    url,
  })
}

// 用户 - 创建房树人信息
// 【POST】/staff/houseTreePerson/create
// 入参
// imgUrl
export async function createHouseTreePerson(params) {
  const url = `/staff/houseTreePerson/create`;
  return await _request({
    method: 'POST',
    url,
    data: params,
  })
}

// 获取房树人最近一条记录 staff/houseTreePerson/getLast
export async function getLastHouseTreePerson() {
  const url = `/staff/houseTreePerson/getLast`;
  return await _request({
    method: 'GET',
    url,
  })
}

// 4./staff/{ ACTIVITY_CODE }/create--通用提交活动接口
export async function createActivity(activityCode, params) {
  const url = `/staff/${activityCode}/create`;
  return await _request({
    method: 'POST',
    url,
    data: params,
  })
}

// 查询团体报告
export async function getGroupReport() {
  const url = `/staff/diyAiChild/getLastTeamReport`;
  return await _request({
    method: 'GET',
    url
  })
}

// 生成团体报告 【POST】/staff/diyAiChild/createTeamReport    
export async function createTeamReport(params) {
  const url = `/staff/diyAiChild/createTeamReport`;
  return await _request({
    method: 'POST',
    url,
    data: params,
  })
}

// 查询单个活动getByActivityCode
export async function getByActivityCode(params) {
  const url = `/staff/activity/getByActivityCode${_getQuerystr(params)}`;
  return await _request({
    method: 'GET',
    url,
  })
}

// 根据avatarId查询治疗师信息 :/avatar/{avatarId}
export async function getAvatarInfo(avatarId) {
  const url = `/avatar/${avatarId}`;
  return await _request({
    method: 'GET',
    url,
  })
}

// GET /staff/diyAiChild/avatar?teamActivityInstance= 根据团体活动实例查询avatar
export async function getAvatarByTeamActivity(teamActivityInstanceId) {
  const url = `/staff/diyAiChild/avatar${_getQuerystr({ teamActivityInstanceId })}`;
  return await _request({
    method: 'GET',
    url,
  });
}

// GET /staff/diyAiChild/avatarForCardRound?teamActivityInstanceId= 根据塔罗牌轮次聊天场景查询avatar
export async function getAvatarForCardRound(teamActivityInstanceId) {
  const url = `/staff/diyAiChild/avatarForCardRound${_getQuerystr({ teamActivityInstanceId })}`;
  return await _request({
    method: 'GET',
    url,
  });
}
